export default "__VITE_ASSET__BrOwcCuH__"